import styled from 'styled-components';

export const SectionCampus = styled.div`
  padding: 50px 0;

  @media (max-width: 991.98px) {
    padding-bottom: 0;
    margin-top: 30px;
    background: #f7f7f7;
  }
`;

export const SectionCaption = styled.div`
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  text-align: center;

  h2 {
    color: #4a4a4a;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,serif' : '')};
    @media (max-width: 991.98px) {
      margin-bottom: ${({ dir }) => (dir === 'rtl' ? '30px' : '')};
    }
    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
      line-height: ${({ dir }) => (dir === 'rtl' ? '25px' : '')};
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '16px')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
    line-height: 20px;
    color: ${({ dir }) => (dir === 'rtl' ? '#898989' : '#4a4a4a')};
    @media (max-width: 991.98px) {
      margin-bottom: ${({ dir }) => (dir === 'rtl' ? '2.75rem' : '')};
    }
  }
`;

export const SliderWrapper = styled.div`
  display: none;

  @media (min-width: 480px) and (max-width: 820px) and (max-height: 400px) {
    display: none;
  }

  @media (min-width: 768px) {
    display: block;
  }
`;

export const SliderWrapperHistory = styled.div`
  &.sldr_history_block {
    display: flex;

    @media (max-width: 992px) {
      display: block;
    }
  }

  .slidr_histry_left {
    width: 100%;
    text-align: center;

    .slick-track {
      .slick-slide {
        height: 595px;
        border: none;

        @media (max-width: 991.98px) {
          height: 435px;
        }

        @media (max-width: 767.98px) {
          height: auto;
        }
      }
    }

    p {
      @media (max-width: 767.98px) {
        text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
        margin-right: ${({ dir }) => (dir === 'rtl' ? '15px' : '')};
      }
    }
  }

  figure {
    margin: 0px;
    position: relative;
    margin-bottom: 1rem;
    width: 855px;
    height: 530px;

    .lazy-load-image-background {
      width: 100%;
      height: 100%;
      display: block;
    }

    &[dir='ltr'] {
      margin-left: 15px;
    }

    &[dir='rtl'] {
      margin-right: 15px;
    }

    @media (max-width: 991.98px) {
      width: 100%;
      height: auto;
    }

    @media (max-width: 767.98px) {
      width: 100%;
      height: auto;
      margin-top: 10px;
    }

    figcaption {
      padding: 5px 0;
      justify-content: center;
      width: 78px;
      color: #fff;
      display: inline-flex;
      background: #1b7bdd;
      font-size: 25px;
      position: absolute;
      top: 24px;

      &[dir='ltr'] {
        left: -15px;
      }

      &[dir='rtl'] {
        right: -15px;
      }

      @media (max-width: 767.98px) {
        padding: 2px 0;
        top: -8px;
        font-size: 10px;
        width: 45px;
      }
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;

      @media (max-width: 767.98px) {
        margin-left: -15px;
      }
    }
  }
`;

export const ThumbNailSlider = styled.div`
  padding: 0 80px;
  background-color: #f7f7f7;
  text-transform: uppercase;

  .slick-dots {
    display: none !important;
  }

  .slick-current:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    transition: 0.3s;
    background-color: #1ba39c;
  }

  .slick-slide {
    border-left: 1px solid #fff;
    border-top: 0;
    border-bottom: 0;
    position: relative;
    cursor: pointer;
    float: ${({ dir }) => (dir === 'rtl' ? 'left' : '')};
  }

  .slick-current {
    .slick-slide {
      &.green {
        border-bottom: 1px solid #1ba39c;
      }
      &.red {
        border-bottom: 1px solid #ce445b;
      }
      &.secondary {
        border-bottom: 1px solid #1b7bdd;
      }
    }
  }

  &.thumbnail-slider-wrap {
    &[dir='rtl'] {
      .slick-prev {
        left: -70px;
        right: auto;
      }
      .slick-next {
        left: auto;
        right: -70px;
      }
    }
  }
`;

export const SlickSlide = styled.div`
  height: 102px !important;
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  text-align: center;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : '')};
  padding: 0 15px;
`;

export const CampusImageMobile = styled.div`
  display: none;
  width: 100%;
  padding: 0 5%;
  margin: 0 auto;
  position: relative;

  @media (min-width: 480px) and (max-width: 820px) and (max-height: 400px) {
    display: block;
  }

  @media (max-width: 767px) {
    display: block;
  }
`;

export const CampusImg = styled.div`
  position: relative;
  span {
    display: block !important;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

export const MobilePortrait = styled.div`
  display: none;
  margin: 0;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  height: 100%;
  flex-flow: column;
  justify-content: center;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  padding: 0 10%;

  p {
    color: #fff;
    line-height: 1.3;
    font-size: 1.25rem;
    margin: 0;
  }

  @media (max-width: 480px) {
    display: flex;
  }
`;

export const ImageCarousel = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const ThumbNailSliderHistory = styled.div`
  &.slidr_histry_rgt {
    position: absolute;
    top: 25%;

    @media (min-width: 768px) {
      max-width: 90px;
      padding: 35px 0;
    }

    @media (max-width: 991px) {
      top: 50px;
    }

    @media (max-width: 767px) {
      width: 80%;
      margin: 1rem auto;
      position: relative;
      text-align: center;
      top: 0;
      right: 0;
      margin-bottom: 2rem;
    }

    &[dir='ltr'] {
      @media (min-width: 768px) {
        right: -15%;
      }

      @media (max-width: 991px) and (min-width: 768px) {
        right: -100px;
      }

      .slider_dot {
        margin-right: 5px;
        float: left;

        @media (max-width: 767px) {
          margin: 1.5rem auto 0.5rem;
          float: none;
        }
      }
    }

    &[dir='rtl'] {
      @media (min-width: 768px) {
        left: -15%;
      }

      @media (max-width: 991px) and (min-width: 768px) {
        left: -100px;
      }

      .slider_dot {
        margin-left: 5px;
        float: right;

        @media (max-width: 767px) {
          margin: 1.5rem auto 0.5rem;
          float: none;
        }
      }

      div[dir='ltr'] {
        .slick-arrow {
          left: auto;
          right: 5px;
        }
      }
    }

    @media (max-width: 991.98px) {
      display: inherit;
      width: 100%;
      margin-top: 20px;
    }

    @media (max-width: 767.98px) {
      max-width: 80%;
      margin: 1rem auto;
      position: relative;
      text-align: center;
      top: 0;
      margin-bottom: 0rem;
    }

    .slick-list {
      .slick-slide {
        display: block;
        height: auto;
        border: 1px solid transparent;
        min-height: 1px;
        float: left;

        @media (max-width: 767px) {
          position: relative;
          margin-bottom: 20px;
          overflow: visible;
        }
      }
    }
  }

  .slick-current {
    .story_year {
      display: block;
    }

    .slider_dot {
      border: 1px solid #65a1e9;
    }
  }

  .slick-dots {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 100%;
    position: relative;
    display: none !important;
  }

  .slick-arrow {
    width: 20px;
    height: 20px;
  }

  .slick-prev {
    left: 0;
    top: inherit;
    margin: -1rem 0;

    @media (max-width: 767.98px) {
      left: 0px !important;
      top: 50%;
      margin: 0 -1rem;
    }

    @media (max-width: 767.98px) {
      margin-top: -12px;
    }

    &:before {
      transform: rotate(225deg) !important;

      @media (max-width: 767.98px) {
        transform: rotate(135deg) !important;
      }
    }
  }

  .slick-next {
    left: 0;
    top: inherit;
    margin: 1rem 0;

    @media (max-width: 767.98px) {
      top: 50%;
      right: -25px !important;
      margin: 0 1rem;
      margin-top: -12px;
      left: inherit;
    }

    &:before {
      transform: rotate(45deg) !important;

      @media (max-width: 767.98px) {
        transform: rotate(-45deg) !important;
      }
    }
  }
`;

export const SlickSlideHistory = styled.div`
  .slider_dot {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 100%;
    float: left;
    position: relative;

    &:after {
      position: absolute;
      content: '';
      width: 12px;
      height: 12px;
      background: #f2f2f2;
      border-radius: 100%;
      top: 0px;
      left: 4px;
      bottom: 0;
      margin: auto;

      @media (max-width: 768px) {
        left: 4px;
      }
    }
  }

  .story_year {
    margin-bottom: 0;
    color: #000;
    font-size: 25px;
    display: none;

    @media (max-width: 767px) {
      position: absolute;
      z-index: 99;
      left: 50%;
      bottom: -20px;
      transform: translateX(-50%);
    }

    @media (min-width: 768px) {
      &[dir='ltr'] {
        padding-left: 5px;
      }

      &[dir='rtl'] {
        padding-right: 5px;
      }
    }

    @media (max-width: 767.98px) {
      margin-top: 15px;
    }
  }
`;

export const OurHistory = styled.div`
  padding: 50px 0;
  overflow: hidden;

  @media (max-width: 767.98px) {
    padding: 50px 0 20px;
  }
`;

export const HistoryCaption = styled.div`
  max-width: 870px;
  margin: 0 auto;
  position: relative;
  text-align: center;

  @media (max-width: 1199.98px) {
    max-width: 750px;
  }

  @media (max-width: 991.98px) {
    max-width: 550px;
  }

  h2 {
    color: #4a4a4a;

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    color: #898989;
    margin-bottom: 1.5rem;
  }
`;

export const Historywidth = styled.div`
  position: relative;
  max-width: 870px;
  margin: 0 auto;

  @media (max-width: 1199px) {
    max-width: 750px;
  }

  @media (max-width: 991px) {
    max-width: 550px;
  }
`;

export const CampusImage = styled.div`
  .slider-full {
    .slick-slide {
      height: auto;

      & > div {
        text-align: center;
        & > span {
          height: auto !important;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .slick-slide {
    height: 600px;
    float: ${({ dir }) => (dir === 'rtl' ? 'left' : '')};

    & > div {
      width: 100% !important;
      img,
      & > span {
        display: block !important;
        width: 100%;
      }
    }

    @media (max-width: 1099px) {
      position: relative;
      overflow: hidden;
      height: 400px;
    }
  }
`;
